// 当前运行环境，定义在 .env.[dev|sit|prod] 文件里
export const APP_ENV = process.env.VUE_APP_ENV;

// 环境名称枚举
export const ENV_NAME = {
	DEV : 'dev',
	SIT : 'sit',
	PROD: 'prod'
};

// 环境配置
export const ENV_CONFIG_ALL = {
	[ ENV_NAME.DEV ] : {
		HTTP_URL : 'https://c2bt4.maxuscloud.com', 
	},
	[ ENV_NAME.SIT ] : {
		HTTP_URL : 'https://c2bt4.maxuscloud.com', 
	},
	[ ENV_NAME.PROD ]: {
		HTTP_URL : 'https://c2b.saicmaxus.com', 
	}
};

// 当前环境配置
export const ENV_CONFIG = ENV_CONFIG_ALL[ APP_ENV ] || ENV_CONFIG_ALL.prod;